import { IPlayer, ITeam } from "../../../../../types/api";

const calculateDateAdded = (
    p: IPlayer,
    team: ITeam | undefined,
    ageLevel: ITeam["ageLevels"][number] | undefined,
) => {
    const teamYear = p.teams.find(t => t.year === ageLevel?.year);

    if (teamYear) {
        if (teamYear.primary) {
            return teamYear.primary.id === team?.id
                ? new Date(teamYear.primary.dateAdded).toLocaleDateString(
                      "en-US",
                      {
                          dateStyle: "short",
                      },
                  )
                : null;
        } else if (teamYear.secondary) {
            const secondaryTeam = teamYear.secondary.find(
                t => t.id === team?.id,
            );

            return (
                secondaryTeam &&
                secondaryTeam.dateAdded &&
                new Date(secondaryTeam.dateAdded).toLocaleDateString("en-US", {
                    dateStyle: "short",
                })
            );
        }
    }

    return null;
};

export default calculateDateAdded;
